import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import ProtectedRoute from '../../routes/ProtectedRoute';
const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));

const PUBLIC_PATHS = ['/', 'auth-pages/login', 'auth-pages/sign-up', 'auth-pages/404', 'verify/:code', 'privacy-policy', 'reporter-privacy-policy', 'delete-account', 'reporter-delete-account', 'contact-us'];

const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => (
				<Route
                    key={page.path}
                    {...page}
                    element={
                        PUBLIC_PATHS.includes(page.path||'')
                            ? page.element
                            : <ProtectedRoute>{page.element}</ProtectedRoute>
                    }
                />
			))}
			<Route path='*' element={<PAGE_404 />} />
		</Routes>
	);
};

export default ContentRoutes;
